import React from "react";
import './Disclaimer.scss';

class Disclaimer extends React.Component{
  constructor(props){
    super(props);
    this.disclaimer_page_ref = React.createRef();
  }

  render(){
    return(
      <div className="disclaimer_page_container page_container" ref={this.disclaimer_page_ref}>
        <div className="page_title">
              <div className="title_ghost"></div>
              <div className="title">Disclaimer</div>
          </div>
        <div className="disclaimer_container">
          <div className="home_link" onClick={() => this.props.history.push("/")}>HOME</div>
          <div className="page_link">DISCLAIMER</div>
          <p>This disclaimer policy is to be read in conjunction with the Terms & Conditions of this website and will be applicable for everyone who browse or deal with <b>amrityum.com</b> in any manner.</p>
          <p>The information contained on this website is for general information purposes only. The information is provided by <b>amrityum.com</b> and its contributors through various entries that they directly make. While we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.</p>
          <p>In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.</p>
          <p>Through this website, you may be able to link to other websites which are not under the control of <b>amrityum.com</b>. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</p>
          <p>Every effort is made to keep the website up and running smoothly. However, <b>amrityum.com</b> takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.</p>
        </div>
      </div>
    )
  }
}

export default Disclaimer;